import type { StylePanelCombinedProps } from './types';

const usePresenter = (props: StylePanelCombinedProps): StylePanelCombinedProps => {
  return props;
};

export default usePresenter;
